<script setup lang="ts">
import { Link } from '@inertiajs/vue3'
import { Button } from '@/Components/ui/button'
import { consentBannerOpen, consentDecide } from '@/lib/consent'
</script>

<template>
  <div
    v-if="consentBannerOpen"
    role="dialog"
    aria-labelledby="cookie-consent-title"
    class="fixed inset-x-0 bottom-0 z-50 border-t border-line bg-surface p-4 shadow-lg sm:inset-x-auto sm:bottom-4 sm:left-4 sm:max-w-md sm:rounded-xl sm:border"
  >
    <h2 id="cookie-consent-title" class="font-sans text-base font-bold text-ink">Cookies and analytics</h2>
    <p class="mt-2 text-sm text-muted">
      With your agreement, we use Google Analytics, Lucky Orange, PostHog and the Meta Pixel to see how Bindle is used and improve it. Lucky Orange and PostHog record how pages are used, with anything typed hidden. Nothing loads unless you accept, and you can change your mind at any time from “Cookie settings” in the site’s footer or the privacy policy.
      <Link href="/privacy-policy" class="font-medium text-brand underline">Privacy policy</Link>
    </p>
    <div class="mt-4 flex gap-3">
      <Button class="flex-1" @click="consentDecide(true)">Accept</Button>
      <Button class="flex-1" variant="outline" @click="consentDecide(false)">Reject</Button>
    </div>
  </div>
</template>
